import React, { useContext } from "react";
import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Button, Row } from "reactstrap";
import SikkaInput from "../common/SikkaInput";
import APICall from "../../services/apiCall";
import { toast } from "react-toastify";
import AppContext from "../../context/Context";

const UserUpdateEmailModal = ({
  devid,
  applicationDetails,
  selectedPartnerCustomer,
  setShowUserUpdateEmailModal,
  setUpdateDataFlag,
}) => {
  const { loginUserDetails } = useContext(AppContext);

  const { register, handleSubmit, setValue, errors } = useForm();

  const onSubmit = (values) => {
    const body = {
      app_id: applicationDetails.app_id,
      master_customer_id: selectedPartnerCustomer.master_customer_id,
      new_email_address: values.newEmail,
      app_name: selectedPartnerCustomer.app_name,
      dev_id: devid,
      partner_name: selectedPartnerCustomer.partner_name,
      updated_by: loginUserDetails.user_name,
      old_email_address: selectedPartnerCustomer.po_user_name,
      is_add_updated_by_admin: loginUserDetails.is_partner === "0" ? "true" : "false", //Value should be true/false. if update from admin side then value must be true else false
      user_dev_id:loginUserDetails.dev_id
    };
    APICall.servertrip("PUT", "partners_customer_email", loginUserDetails, undefined, body).then(
      (res) => {
        setShowUserUpdateEmailModal(false);
        setUpdateDataFlag(true);
        toast.success("New email successfully changed");
      },
      (error) => {
        const resMessage =
          (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        toast.error(resMessage);
        setUpdateDataFlag(false);
      }
    );
  };

  return (
    <div>
      <Form className="m-1" onSubmit={handleSubmit(onSubmit)}>
        <SikkaInput
          label="New Email"
          name="newEmail"
          id="newEmail"
          placeholder="New Email"
          innerRef={register({
            required: "New Email is required",
            pattern: {
              value:/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
              message: "Invalid email address",
            },
          })}
          errors={errors}
        />
        <Row className="modal-footer bg-light" style={{ marginBottom: "-16px" }}>
          <Button className="ml-auto" size="sm" color="outline-primary" type="submit">
            Save
          </Button>
          <Button
            size="sm"
            color="outline-danger"
            onClick={() => {
              setShowUserUpdateEmailModal(false);
            }}
          >
            Cancel
          </Button>
        </Row>
      </Form>
    </div>
  );
};

export default UserUpdateEmailModal;
